import baseAPI from '@/api';
import { RankGroup } from '@/models/rank/group';
import { QueryFunctionContext } from '@tanstack/react-query';
import { RankGroupsQueryKeys } from '../../queryKeys';
import { RankGroupByIdRequestDto } from '@/services/dto/rank-groups/rank-group-by-id-request.dto';

export async function fetchRankGrouById({
  queryKey,
}: QueryFunctionContext<[RankGroupsQueryKeys.ById, RankGroupByIdRequestDto]>) {
  const { id } = queryKey[1];
  const response = await baseAPI.get<RankGroup>(`/rank-groups/${id}`);
  return response.data;
}
